import graphql__eb63c934f0cb72a80481 from "./__generated__/ContributionsDatavizThemeMeasures_theme.graphql.js";import { graphql, useFragment } from "react-relay";
import { defineMessages } from "react-intl";

import { useFormatMessage } from "../../../Intl/Context";
import Icon from "../../../Utils/Icon";

const ContributionsDatavizThemeMeasures = props => {
  const { contributionsCount, reactionsCount } = useFragment(
    ContributionsDatavizThemeMeasures_theme,
    props.theme
  );

  const t = useFormatMessage();
  const contributionsLabel = t(intlMessages.contributions, { count: contributionsCount });
  const reactionsLabel = t(intlMessages.reactions, { count: reactionsCount });

  return (
    <div className={props.className}>
      <ul className="d-flex list-unstyled padding-none margin-bottom-none">
        <li className="flex-1 text-truncate margin-right-xs">
          <span className="text-primary margin-right-xxs nowrap">
            <Icon className="icon-pencil align-middle margin-right-xxs" />
            {contributionsCount}
          </span>
          {contributionsLabel}
        </li>

        <li className="flex-1 text-truncate">
          <span className="text-primary margin-right-xxs nowrap">
            <Icon className="dataviz-reactions align-middle margin-right-xxs" />
            {reactionsCount}
          </span>
          {reactionsLabel}
        </li>
      </ul>
    </div>
  );
};

const ContributionsDatavizThemeMeasures_theme = graphql__eb63c934f0cb72a80481;

export default ContributionsDatavizThemeMeasures;

const intlMessages = defineMessages({
  contributions: {
    id: "contributions.dataviz.sidebar.contributions",
    defaultMessage: "{count, plural, one { contribution } other { contributions }}"
  },
  reactions: {
    id: "contributions.dataviz.sidebar.reactions",
    defaultMessage: "{count, plural, one { réaction } other { réactions }}"
  }
});
